import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Heading } from 'goustouicomponents'
import { ContentLoader } from '../../ContentLoader'
import css from './JobCard.module.css'
import { useFetchOpenings } from '../../../hooks/useFetchOpenings'
import { chevronRightBlue } from '../../../assets/icons/Chevrons'

const JobCard = ({ department, jobTitle, jobURL, hasGreyBackground }) => {
  const [url, updateUrl] = useState()

  const { fetchResponse, isFetchLoading } = useFetchOpenings(url)

  const handleRetrievePosting = () => {
    window.gtag('click', 'view_jobs', {
      jobTitle,
      department,
    })
    updateUrl(jobURL)
  }

  useEffect(() => {
    if (fetchResponse?.postingUrl) {
      window.location.href = fetchResponse.postingUrl
      updateUrl()
    }
  }, [fetchResponse])

  return (
    <div
      className={classnames(css.jobCard, {
        [css.backgroundGrey]: hasGreyBackground,
      })}
    >
      <Heading type="h6" size="fontStyleM">
        {jobTitle}
      </Heading>
      <p>{department}</p>
      <div className={css.readMore}>
        <button
          onClick={handleRetrievePosting}
          type="button"
          data-title={jobTitle}
          data-department={department}
          className={css.jobLink}
        >
          <span className={css.linkContent}>
            {isFetchLoading ? (
              <ContentLoader inJobCard />
            ) : (
              <>
                Read more
                {chevronRightBlue}
              </>
            )}
          </span>
        </button>
      </div>
    </div>
  )
}

JobCard.propTypes = {
  department: PropTypes.string,
  jobTitle: PropTypes.string.isRequired,
  jobURL: PropTypes.string.isRequired,
  hasGreyBackground: PropTypes.bool,
}

JobCard.defaultProps = {
  department: null,
  hasGreyBackground: false,
}

export { JobCard }
